import Footer from '../Footer/Footer';
import Header from '../Header/Header';

import './PersonalDataConsent.css';

const PersonalDataConsent = () => (
  <>
    <Header />
    <div className="personal_data_consent">
      <h1 className="personal_data_consent-title">
        Согласие на обработку персональных данных - физических лиц
      </h1>

      <p>
        Отправляя сообщение через форму обратной связи (оставляя заявку на
        интернет-сайте{' '}
        <a
          href="https://шахматыпермь.рф"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://шахматыпермь.рф
        </a>
        ) и нажимая кнопку «Оставить заявку», я, действуя по своей воле и в
        своих интересах и/или в интересах несовершеннолетнего ребёнка, настоящим
        осознанно и добровольно даю ООО «Шахматная Школа» (ОГРН 1155958015421,
        ИНН 5905026580, юридический адрес: 614016, г. Пермь, ул. Куйбышева, д.
        54; далее — Оператор) согласие на обработку моих персональных данных,
        указанных в форме обратной связи, включая фамилию, имя, отчество,
        контактный телефон, адрес электронной почты, дату рождения и имя ребенка
        и иные сведения, предоставленные мной в сообщении, исключительно в
        целях:
      </p>

      <ul className="personal_data_consent-list">
        <li>Рассмотрения и регистрации моего обращения;</li>
        <li>Предоставления ответа, связи со мной по указанным контактам;</li>
        <li>Заключения и исполнения договоров об оказании услуг;</li>
        <li>Консультирования относительно программ обучения;</li>
        <li>
          Направления информационных и сервисных уведомлений, связанных с
          деятельностью Оператора;
        </li>
        <li>Исполнения требований законодательства Российской Федерации.</li>
      </ul>

      <p>
        Также я уведомлен(а) и даю согласие на использование Оператором сервиса{' '}
        <strong>Яндекс.Метрика</strong> (Яндекс, ООО, Россия) для сбора
        обезличенных статистических данных о посещениях и действиях
        Пользователей на сайте. Яндекс.Метрика может автоматически получать
        обезличенные технические данные, включая IP-адрес (в обезличенном виде),
        информацию о браузере, устройстве, времени посещения и действиях на
        сайте. Эти данные используются исключительно для анализа посещаемости,
        улучшения качества работы сайта и повышения удобства пользователей.
      </p>

      <p>
        Пользователь вправе отключить передачу данных в Яндекс.Метрику,
        установив плагин{' '}
        <a
          href="https://yandex.ru/support/metrica/general/opt-out.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          «Блокировка сбора данных Метрики»
        </a>{' '}
        либо изменив настройки файлов Cookie в своём браузере.
      </p>

      <br />

      <p>
        Под обработкой персональных данных я подтверждаю своё согласие на
        совершение с указанными мною данными следующих действий: сбор, запись,
        систематизацию, накопление, хранение, уточнение (обновление, изменение),
        извлечение, использование, передачу (в том числе третьим лицам –
        платёжному агрегатору ООО НКО ЮМани, почтовым/курьерским организациям и
        IT-подрядчикам — исключительно в целях исполнения моего обращения),
        обезличивание, блокирование, уничтожение и удаление, как с
        использованием средств автоматизации, так и без их использования.
      </p>

      <br />

      <p>
        Я уведомлен(а) и соглашаюсь с тем, что срок обработки моих персональных
        данных составляет срок до момента моего отзыва согласия или направления
        требования об их удалении, либо в течение трёх лет после завершения
        договорных отношений, либо до прекращения деятельности ООО «Шахматная
        школа». Отзыв согласия возможен путём направления письменного
        уведомления на адрес электронной почты Оператора:{' '}
        <a href="mailto:chessperm@yandex.ru">chessperm@yandex.ru</a>.
      </p>

      <br />

      <p>
        Я подтверждаю, что ознакомлен(а) с Политикой обработки персональных
        данных, размещённой в сети Интернет по адресу{' '}
        <a
          href="https://шахматыпермь.рф/personal_data_consent"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://шахматыпермь.рф/personal_data_consent
        </a>{' '}
        {/* и по адресу{' '}
        <a
          href="https://storage.yandexcloud.net/chessschoolfrontendfiles/personal_data_consent.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://storage.yandexcloud.net/chessschoolfrontendfiles/personal_data_consent.pdf
        </a> */}
        , и всеми условиями, изложенными в настоящем Согласии.
      </p>
    </div>
    <Footer />
  </>
);

export default PersonalDataConsent;
